/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardTypeDTO
 */
export interface CardTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof CardTypeDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeDTO
     */
    name?: string;
}

export function CardTypeDTOFromJSON(json: any): CardTypeDTO {
    return CardTypeDTOFromJSONTyped(json, false);
}

export function CardTypeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTypeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CardTypeDTOToJSON(value?: CardTypeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

